import React, { useEffect } from "react";
import Translate from "../components/Translate";
import { useTranslation } from "react-i18next";
import { updateMetaTags } from "../utils/seo";
import PageBanner from "../components/PageBanner";
import GrievanceFormBase from "../components/GrievanceFormBase";

export default function GrievanceForm() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    updateMetaTags(
      `${t('grievance-form')} | ${t('site-title')}`,
      t('grievance-desc'),
      t('grievance-keywords')
    );
  }, [t, i18n.language]);

  return (
    <div className="w-full min-h-[80vh] bg-primary-50 pb-16">
      <PageBanner
        title={<Translate text={"grievance-form"} />}
        subtitle={<Translate text={'grievance-subtitle'} />}
        badgeText={t('badge-grievance-cell')}
      />
      <GrievanceFormBase />
    </div>
  );
}
